<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}" class="layout-padd">
    <div fxLayoutAlign="start center">
        <mat-icon color="warn">warning</mat-icon>
    </div>
    
    <!-- Content  -->
    <div fxLayout="column" fxLayoutAlign="center center" class="layout-padd" fxLayoutGap="25px">
        <img src="assets/img/icons/empty-basket.png" style="height: 50px" />

        <div class="h1">{{ "basket.empty_" | translate }}</div>

        <div class="mat-subheading-1">{{ "basket.time" | translate }}</div>
    </div>


    <!-- Close btn -->

    <div style="position: absolute;bottom: 20px;left:0;width: 100%;">
        <div fxLayout="column" fxLayoutAlign="center center" class="layout-padd">

            <button mat-stroked-button class="dark-ico full-w" (click)="closeDial()" angulartics2On="click">
                <span class="mat-title">{{"dialogs.go-back" | translate}}</span>
            </button>

        </div>
    </div>

</div>